import { setFramedLayout } from "./layouts"
import { oneOloaderHtml } from "./loaderHtml"
import { track, getPageDomInteractiveTimestamp } from "./helpers"

export function openStorefront(storefrontIdOrUrl, options) {
  const isUrl =
    storefrontIdOrUrl.includes(window.OneO.shopEnv.checkoutAppBase) ||
    storefrontIdOrUrl.includes("/checkouts/")
  const trackUrl = isUrl
    ? storefrontIdOrUrl
    : window.OneO.shopEnv.checkoutAppBase + "/checkouts/" + storefrontIdOrUrl
  track(trackUrl, "content_click")
  let url
  if (isUrl) {
    url = storefrontIdOrUrl
  } else {
    url =
      window.OneO.shopEnv.checkoutAppBase +
      "/checkouts/" +
      storefrontIdOrUrl +
      "#"
  }
  openStorefrontUrl(url, options, (element) => {
    element.classList.add("io-1o-Container-show")
  })
}

// todo: add placement id to hash, sequent number if none specified
function openStorefrontUrl(url, options = {}, callback) {
  setTimeout(() => {
    // timeout ensures body exists
    const element = document.createElement("div")
    element.className = "io-1o-Container"
    element.innerHTML = oneOloaderHtml()
    element.options = options = Object.assign(
      {
        parentNode: document.body,
        r: encodeURIComponent(document.referrer),
        pt: encodeURIComponent(document.title),
        pu: encodeURIComponent(window.location.href),
        tdi: encodeURIComponent(getPageDomInteractiveTimestamp()),
        insertBeforeNode: null,
        pageLock: true,
        preload: false,
        open: false,
        mode: "popup",
        width: 650,
        height: 365,
        showClose: true
      },
      options
    )
    if (typeof options.pageLock != "boolean") {
      options.pageLock = options.pageLock === "true"
    }
    /*
     * !!IMPORTANT!!
     * If we ever introduce new mode, organize parameters better in code
     *
     */

    let containerStyle

    switch (options.mode) {
      case "popup":
      case "fullframe":
        containerStyle = `position: fixed; top: 0; bottom: 0; right: 0; width: 100vw; min-height: 100vh; min-height: fill-available; min-height: -webkit-fill-available; z-index: calc(9e999);`
        break
      case "rightTray":
        containerStyle = ``
        if (!options.pageLock) {
          containerStyle = `width: 360px;`
        }
        break
      default:
        containerStyle = `position: relative; width: ${options.width}px; height: ${options.height}px`
    }
    element.style.cssText = containerStyle

    options.parentNode.insertBefore(element, options.insertBeforeNode)
    if (["popup", "rightTray"].includes(options.mode)) {
      if (options.pageLock) {
        element.addEventListener("wheel", (event) => event.preventDefault())
        element.addEventListener("touchmove", (event) => event.preventDefault())
      }
    }
    if (!options.hasOwnProperty("sendImpression")) {
      if (options.mode === "inline") {
        options.sendImpression = !!isInViewport(element)
      }
      if (options.preload) {
        options.sendImpression = false
      }
    }

    var sscid = new URL(document.location.href).searchParams.get("sscid")
    if (!options.shareasaleId && sscid) {
      options.shareasaleId = sscid
    }

    setFramedLayout({
      containerElement: element,
      contentElement: element.querySelector(".io-1o-Container-content"),
      borderElement: element.querySelector(".io-1o-Container-border"),
      viewportWidth: element.clientWidth,
      viewportHeight: element.clientHeight,
      theme: options
    })

    let forwardedOptions = []
    for (let key in options) {
      if (
        !["parentNode", "insertBeforeNode", "width", "height"].includes(key)
      ) {
        forwardedOptions.push(`${key}=${options[key]}`)
      }
    }

    if (forwardedOptions.length > 0 && forwardedOptions !== "") {
      if (url.indexOf("#") === -1) {
        url += "#"
      }
      url += forwardedOptions.join("/")
    }

    element.querySelector("iframe").src = url
    if (callback) {
      callback(element)
    }
  }, 0)
}

export function openStorefrontAnchor(
  anchor,
  isClicked,
  reportContentClick = false
) {
  if (reportContentClick) {
    track(anchor.href, "content_click")
  }
  const hashIndex = anchor.href.indexOf("#")
  const args = { mode: "popup" }
  let url
  if (hashIndex !== -1) {
    url = anchor.href.substring(0, hashIndex + 1)
    for (let hashSlice of anchor.href.substring(hashIndex + 1).split("/")) {
      if (hashSlice.includes("=")) {
        const [key, argument] = hashSlice.split("=")
        args[key] = argument
      } else {
        if (hashSlice) {
          url += "/" + hashSlice
        }
      }
    }
  } else {
    url = anchor.href
  }
  const open = String(args.open) === "true"
  const shouldPreloadNow =
    String(args.preload) === "true" && !isClicked && !open
  if (isClicked || open || shouldPreloadNow) {
    // if inline setup properties to insert after link
    if (!["popup", "fullframe", "rightTray"].includes(args.mode)) {
      args.parentNode = anchor.parentNode
      args.insertBeforeNode = anchor.nextSibling
    }
    // if order finished delete _1o_loadedElement to restart from begining
    if (anchor._1o_loadedElement && anchor._1o_loadedElement.isOrderFinished) {
      anchor._1o_loadedElement.parentNode.removeChild(anchor._1o_loadedElement)
      delete anchor._1o_loadedElement
    }
    // if already loaded
    if (
      anchor._1o_loadedElement &&
      anchor._1o_loadedElement._1o_shopUrl === url
    ) {
      showElement(anchor._1o_loadedElement)
      // if preloaded trigger impression
      if (String(args.preload) === "true") {
        let iframe = anchor._1o_loadedElement.querySelector("iframe")
        let iframeContentWindow =
          iframe.contentWindow || iframe.contentDocument.defaultView
        iframeContentWindow.postMessage(
          {
            type: "OneoEventTrigger",
            data: {
              eventToTrigger: {
                type: "OneoAnalyticsEvent",
                event: "shop_impression"
              }
            }
          },
          "*"
        )
      }
      // if inline and not preloading right now, show it
      if (
        !["popup", "fullframe", "rightTray"].includes(args.mode) &&
        !shouldPreloadNow
      ) {
        anchor._1o_loadedElement._1o_previousAnchorVisibility =
          anchor.style.visibility
        anchor.style.visibility = "hidden"
        anchor._1o_loadedElement._1o_anchor = anchor
        setTimeout(
          () => anchor._1o_loadedElement.classList.add("io-1o-Container-show"),
          100
        )
      }
    } else {
      // not loaded yet
      let shopUrl = url
      openStorefrontUrl(url, args, (element) => {
        anchor._1o_loadedElement = element
        element._1o_anchor = anchor
        element._1o_shopUrl = shopUrl
        // if inline and not preloading right now
        if (
          !["popup", "fullframe", "rightTray"].includes(args.mode) &&
          !shouldPreloadNow
        ) {
          element._1o_previousAnchorVisibility = anchor.style.visibility
          anchor.style.visibility = "hidden"
        }
        // show unless preloading
        if (shouldPreloadNow) {
          hideElement(element)
        } else {
          element.classList.add("io-1o-Container-show")
          //    Add event listener that handles impression record when element gets into view
          if (
            element.options &&
            element.options.sendImpression &&
            element.options.sendImpression.toString() === "false"
          ) {
            window.addEventListener("scroll", scrollHandler, {
              passive: true
            })
          }
        }

        function scrollHandler(event) {
          if (isInViewport(element)) {
            let iframe = element.querySelector("iframe")
            let iframeContentWindow =
              iframe.contentWindow || iframe.contentDocument.defaultView
            iframeContentWindow.postMessage(
              {
                type: "OneoEventTrigger",
                data: {
                  eventToTrigger: {
                    type: "OneoAnalyticsEvent",
                    event: "shop_impression"
                  }
                }
              },
              "*"
            )
            window.removeEventListener("scroll", scrollHandler, {
              passive: true
            })
          }
        }
      })
    }
  }
}

function showElement(element) {
  if (element._1o_isHidden) {
    element.style.cssText = element._1o_previousCssText
    element.style.opacity = 1
    element._1o_isHidden = false
    element.ontransitionend = null
    element.style.pointerEvents = "all"
    element.style.display = "block"
  }
}

export function hideElement(element) {
  if (!element._1o_isHidden) {
    if (element._1o_anchor) {
      element._1o_previousCssText = element.style.cssText
      element.style.opacity = 0
      if (element._1o_isHidden !== false) {
        element.style.visibility = "hidden"
        element.style.position = "absolute"
        element.style.left = "-9999px"
        element.style.pointerEvents = "none"
        element.style.display = "none"
      } else {
        element.ontransitionend = () => {
          element.ontransitionend = null
          element.style.visibility = "hidden"
          element.style.position = "absolute"
          element.style.left = "-9999px"
          element.style.pointerEvents = "none"
          element.style.display = "none"
        }
      }
      element._1o_isHidden = true
    } else {
      element.parentNode.removeChild(element)
    }
  }
}

// Determine if an element is in the visible viewport
function isInViewport(element) {
  let rect = element.getBoundingClientRect()
  let html = document.documentElement
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || html.clientHeight) &&
    rect.right <= (window.innerWidth || html.clientWidth)
  )
}
